<!-- ── Page header ────────────────────────────────────────────────────────────── -->
<section class="tg-page-hero">
  <div class="tg-container">
    <h1 class="tg-page-hero__title">Detalles de la Vacante</h1>
    <ul class="tg-page-hero__breadcrumb">
      <li><a routerLink="/">Inicio</a></li>
      <li>›</li>
      <li><a routerLink="/vacantes">Vacantes</a></li>
      <li>›</li>
      <li>Detalles</li>
    </ul>
  </div>
</section>

<!-- ── Vacante cerrada (HTTP 410) — página archivo con noindex ─────────────────── -->
<section style="background:#f9fafb;padding:48px 0 72px;" *ngIf="vacanteCerrada">
  <div class="tg-container">
    <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:48px 32px;text-align:center;max-width:640px;margin:0 auto;">
      <svg style="width:48px;height:48px;color:#94a3b8;margin-bottom:16px;" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
      </svg>
      <h2 style="font-size:20px;font-weight:700;color:#1e293b;margin:0 0 8px;">Esta vacante ya cerró</h2>
      <p style="font-size:14px;color:#64748b;margin:0 0 4px;">
        <strong>{{ detalleVacante?.nombre }}</strong>
        <ng-container *ngIf="$any(detalleVacante)?.nombreEmpresa"> — {{ $any(detalleVacante)?.nombreEmpresa }}</ng-container>
      </p>
      <p style="font-size:13px;color:#94a3b8;margin:0 0 24px;">
        El proceso de reclutamiento finalizó. Te recomendamos revisar vacantes activas similares.
      </p>
      <a routerLink="/vacantes"
         style="display:inline-flex;align-items:center;gap:6px;background:#0066ff;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;font-weight:600;text-decoration:none;">
        Ver vacantes activas
      </a>
    </div>
  </div>
</section>

<!-- ── Error / fallback for GuruMatch scraped jobs ──────────────────────────────── -->
<section style="background:#f9fafb;padding:48px 0 72px;" *ngIf="!detalleVacante && errorMsg">
  <div class="tg-container">
    <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:48px 32px;text-align:center;max-width:560px;margin:0 auto;">
      <svg style="width:48px;height:48px;color:#f59e0b;margin-bottom:16px;" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
      </svg>
      <h2 style="font-size:18px;font-weight:700;color:#1e293b;margin:0 0 8px;">Vacante no disponible en TG Empleos</h2>
      <p style="font-size:14px;color:#64748b;margin:0 0 8px;">{{ errorMsg }}</p>
      <a *ngIf="externalUrl" [href]="externalUrl" target="_blank" rel="noopener"
         style="display:inline-flex;align-items:center;gap:6px;background:#0066ff;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;font-weight:600;text-decoration:none;margin-top:12px;">
        Ver vacante en fuente original
        <svg style="width:14px;height:14px;" viewBox="0 0 20 20" fill="currentColor">
          <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"/>
          <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"/>
        </svg>
      </a>
      <br>
      <a routerLink="/vacantes" style="display:inline-block;margin-top:16px;color:#6b7280;font-size:13px;text-decoration:underline;">← Volver a vacantes</a>
    </div>
  </div>
</section>

<!-- ── Job details body ───────────────────────────────────────────────────────── -->
<section style="background:#f9fafb;padding:48px 0 72px;" *ngIf="detalleVacante && !vacanteCerrada">
  <div class="tg-container">
    <div class="row g-4">

      <!-- ── Main column ── -->
      <div class="col-lg-8">
        <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:32px;">

          <h2 style="font-size:clamp(1.3rem,3vw,1.8rem);font-weight:800;color:#111827;margin:0 0 24px;line-height:1.3;">
            {{detalleVacante.nombre}}
          </h2>

          <!-- Description sections -->
          <div *ngIf="detalleVacante.descripcion" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Descripción</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.descripcion"></div>
          </div>

          <div *ngIf="detalleVacante.experiencia" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Experiencia</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.experiencia"></div>
          </div>

          <div *ngIf="detalleVacante.conocimientos" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Conocimientos</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.conocimientos"></div>
          </div>

          <div *ngIf="detalleVacante.habilidades" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Habilidades</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.habilidades"></div>
          </div>

          <div *ngIf="detalleVacante.actividades" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Actividades</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.actividades"></div>
          </div>

          <div *ngIf="detalleVacante.escolaridad" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Educación</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;" [innerHTML]="detalleVacante.escolaridad"></div>
          </div>

          <div *ngIf="detalleVacante.idiomas" style="margin-bottom:28px;">
            <h3 style="font-size:15px;font-weight:700;color:#111827;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #f0fdf4;">Idiomas</h3>
            <div style="font-size:14px;color:#374151;line-height:1.75;">{{detalleVacante.idiomas}}</div>
          </div>

          <!-- CTA buttons -->
          <div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:32px;">

            <!-- Vacante scrapeada: el candidato va al link original -->
            <ng-container *ngIf="detalleVacante.scrapeUrlOriginal">
              <a *ngIf="!role" class="tg-btn tg-btn--primary" routerLink="/acceder">Iniciar sesión para postularse</a>
              <a *ngIf="role && role == 'candidato'"
                 class="tg-btn tg-btn--primary"
                 [href]="detalleVacante.scrapeUrlOriginal"
                 target="_blank"
                 rel="noopener noreferrer">
                Postúlate en {{
                  detalleVacante.scrapeFuente === 'APIFY_LINKEDIN' ? 'LinkedIn' :
                  detalleVacante.scrapeFuente === 'OCC' ? 'OCC Mundial' :
                  detalleVacante.scrapeFuente === 'COMPUTRABAJO' ? 'Computrabajo' :
                  detalleVacante.scrapeFuente === 'HIRELINE' ? 'Hireline' :
                  detalleVacante.scrapeFuente || 'sitio original'
                }} →
              </a>
            </ng-container>

            <!-- Vacante normal TG Empleos -->
            <ng-container *ngIf="!detalleVacante.scrapeUrlOriginal">
              <a *ngIf="!role" class="tg-btn tg-btn--primary" routerLink="/registrarse">Postúlate ahora</a>
              <ng-container *ngIf="role && role == 'candidato'">
                <span *ngIf="cargandoPostulacion" class="tg-btn" style="background:#f1f5f9;color:#94a3b8;border-color:#e2e8f0;cursor:default;">Cargando...</span>
                <a *ngIf="!cargandoPostulacion && !yaPostulado" class="tg-btn tg-btn--primary"
                   [class.disabled]="postulando" (click)="postularseVacante(detalleVacante)">
                  {{ postulando ? 'Enviando...' : 'Postúlate ahora' }}
                </a>
                <span *ngIf="!cargandoPostulacion && yaPostulado"
                      class="tg-btn"
                      style="background:#ecfdf5;color:#065f46;border-color:#bbf7d0;cursor:default;">
                  ✓ Ya aplicaste
                </span>
              </ng-container>
            </ng-container>

            <a class="tg-btn tg-btn--ghost" href="javascript:void(0)" (click)="regresar()">← Regresar</a>
          </div>

          <!-- CTA: CV hint for logged-in candidates -->
          <div *ngIf="role === 'candidato'"
               style="margin-top:16px;padding:12px 16px;border-radius:12px;border:1px solid #e0f2fe;background:#f0f9ff;display:flex;align-items:center;gap:12px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0284c7" style="width:20px;height:20px;flex-shrink:0;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
            </svg>
            <p style="font-size:13px;color:#0369a1;margin:0;flex:1;">
              ¿Tienes tu CV listo? <a routerLink="/mis-cvs" style="color:#0284c7;font-weight:600;text-decoration:underline;">Sube o gestiona tus CVs</a> para que la IA encuentre vacantes compatibles.
            </p>
          </div>

          <!-- Related courses -->
          <div *ngIf="cursos?.length > 0" style="margin-top:48px;padding-top:32px;border-top:1px solid #e5e7eb;">
            <h3 style="font-size:16px;font-weight:700;color:#111827;margin-bottom:20px;">Cursos Relacionados</h3>
            <div class="courses-slides">
              <owl-carousel-o [options]="optionsSlides">
                <ng-template carouselSlide *ngFor="let curso of cursos">
                  <div class="single-courses-box">
                    <div class="icon">
                      <img loading="lazy" [src]="imgCurso+curso.urlCurso+'.jpg'" [alt]="curso.nombre" [title]="curso.nombre">
                    </div>
                    <h3><a [href]="baseCurso+curso.urlCurso" target="_blank">{{ curso.nombre }}</a></h3>
                  </div>
                </ng-template>
              </owl-carousel-o>
            </div>
          </div>

        </div>
      </div>

      <!-- ── Sidebar ── -->
      <div class="col-lg-4">

        <!-- Datos Generales -->
        <div style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:24px;margin-bottom:16px;">
          <h3 style="font-size:14px;font-weight:700;color:#111827;text-transform:uppercase;letter-spacing:.6px;margin:0 0 20px;">Datos Generales</h3>
          <div style="display:flex;flex-direction:column;gap:14px;">

            <div *ngIf="detalleVacante.salarioMin || detalleVacante.salarioMax" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Oferta Salarial</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">
                  {{(detalleVacante.salarioMin || '') + (detalleVacante.salarioMin && detalleVacante.salarioMax ? ' – ' : '') + (detalleVacante.salarioMax || '')}}
                </span>
              </div>
            </div>

            <div *ngIf="detalleVacante.numVacantes" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Número de Vacantes</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.numVacantes}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.tipoContrato" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Tipo de Contrato</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.tipoContrato}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.tiempoContrato" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Tiempo del Contrato</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.tiempoContrato}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.modalidadEmpleo" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Modalidad del Empleo</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.modalidadEmpleo}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.sexo" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Sexo</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.sexo}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.edad" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 1-3 0 3.353 3.353 0 0 1-3 0 3.354 3.354 0 0 1-3 0l-1.5-.75M8.25 19.5h7.5"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Edad</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.edad}} año(s)</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.idiomas" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Idioma</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.idiomas}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.viajar" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12zm0 0h7.5"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Disponibilidad de Viajar</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.viajar}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.mudar" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Disponibilidad de Mudarse</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.mudar}}</span>
              </div>
            </div>

          </div>
        </div>

        <!-- Datos de Contacto -->
        <div *ngIf="role == 'empresa' || role == 'candidato'"
             style="background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:24px;">
          <h3 style="font-size:14px;font-weight:700;color:#111827;text-transform:uppercase;letter-spacing:.6px;margin:0 0 20px;">Datos de Contacto</h3>
          <div style="display:flex;flex-direction:column;gap:14px;">

            <div *ngIf="detalleVacante.nombreContacto" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0zM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Nombre del Contacto</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">
                  {{detalleVacante.nombreContacto + (detalleVacante.appaternoContacto ? ' ' + detalleVacante.appaternoContacto : '') + (detalleVacante.apmaternoContacto ? ' ' + detalleVacante.apmaternoContacto : '')}}
                </span>
              </div>
            </div>

            <div *ngIf="detalleVacante.cargoContacto" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Cargo ó Función</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.cargoContacto}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.pais" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">País</p>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.pais}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.direccion" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Dirección</p>
                <span *ngIf="estado" style="display:block;font-size:13px;color:#6b7280;">Estado: {{estado.nombre}}</span>
                <span *ngIf="ciudad" style="display:block;font-size:13px;color:#6b7280;">Municipio: {{ciudad.nombre}}</span>
                <span style="font-size:14px;color:#111827;font-weight:600;">{{detalleVacante.direccion}}</span>
              </div>
            </div>

            <div *ngIf="detalleVacante.telefono1Contacto" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25z"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Teléfono 1</p>
                <a [href]="'tel:' + detalleVacante.telefono1Contacto"
                   style="font-size:14px;color:#0066ff;font-weight:600;text-decoration:none;">
                  {{detalleVacante.telefono1Contacto}}
                </a>
                <a *ngIf="detalleVacante.telefono2Contacto && detalleVacante.telefono2Contacto !== 'null'"
                   [href]="'tel:' + detalleVacante.telefono2Contacto"
                   style="display:block;font-size:14px;color:#0066ff;font-weight:600;text-decoration:none;margin-top:4px;">
                  Teléfono 2: {{detalleVacante.telefono2Contacto}}
                </a>
              </div>
            </div>

            <div *ngIf="detalleVacante.correoContacto" style="display:flex;align-items:flex-start;gap:10px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="#0066ff" style="width:18px;height:18px;flex-shrink:0;margin-top:2px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
              </svg>
              <div>
                <p style="font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;margin:0 0 2px;">Correo</p>
                <a [href]="'mailto:' + detalleVacante.correoContacto"
                   style="font-size:14px;color:#0066ff;font-weight:600;text-decoration:none;word-break:break-all;">
                  {{detalleVacante.correoContacto}}
                </a>
              </div>
            </div>

          </div>
        </div>

      </div><!-- /col-lg-4 -->

    </div><!-- /row -->
  </div>
</section>
